import { useEffect } from "react";

const PlanCompensacionRedirect = () => {
  useEffect(() => {
    window.location.replace("/plandecompensacion.html");
  }, []);
  return (
    <div data-testid="plandecompensacion-redirect" style={{ minHeight: "100vh", background: "#00153F" }} />
  );
};

export default PlanCompensacionRedirect;
